import React, { createContext, FC, useState, useEffect, useRef } from "react"

interface ConfettiProps {
	confettiCharacters: string[]
}

export const ConfettiContext = createContext({
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	celebrate: (() => {}) as (emojis?: string[]) => void,
})

export function Confetti({ confettiCharacters }: ConfettiProps) {
	return (
		<div>
			<div>
				{confettiCharacters.map((c, i) => {
					return (
						<span
							key={i}
							style={{
								left: `${Math.random() * (97 - 3 + 1) + 3}%`,
								animationDelay: `${Math.random() * (3 - 0 + 1) + 0}s`,
								animationDuration: `${Math.random() * (2 - 1 + 1) + 1}s`,
							}}
							className="jam--confetti-piece"
						>
							{c}
						</span>
					)
				})}
			</div>
			<style>{`
				.jam--confetti-piece {
					animation: falling 2s linear 1;
					position: fixed;
					top: 110%;
					left: 50%;
					font-size: 5em;
					z-index: 1000003;
				}

				@keyframes falling {
					0% {
						transform: translate3D(0, -150vh, 0) rotate(-540deg);
					}
					100% {
						transform: translate3D(0, 0, 0) rotate(0deg);
					}
				}
			`}</style>
		</div>
	)
}

export const ConfettiProvider: FC<{ timeout?: number }> = ({
	children,
	timeout = 3000,
}) => {
	const [shouldShowConfetti, setShouldShowConfetti] = useState(false)
	const confettiCharacters = useRef<string[]>([
		"🔥",
		"🎉",
		"🌮",
		"🎊",
		"🎉",
		"🔥",
		"🎉",
		"🌮",
		"🎊",
		"🎉",
		"🔥",
		"🎉",
		"🌮",
		"🎊",
		"🎉",
		"🔥",
		"🎉",
		"🌮",
		"🎊",
		"🎉",
		"🔥",
		"🎉",
		"🌮",
		"🎊",
		"🎉",
		"🔥",
		"🎉",
		"🌮",
		"🎊",
		"🎉",
	])

	useEffect(() => {
		if (!shouldShowConfetti) {
			return
		}

		const confettiCleanupTimer = setTimeout(
			() => setShouldShowConfetti(false),
			timeout,
		)
		return () => clearTimeout(confettiCleanupTimer)
	}, [shouldShowConfetti, timeout])

	return (
		<ConfettiContext.Provider
			value={{
				celebrate: (characters?: string[]) => {
					if (characters) {
						confettiCharacters.current = characters
					}
					setShouldShowConfetti(true)
				},
			}}
		>
			{shouldShowConfetti && (
				<Confetti confettiCharacters={confettiCharacters.current} />
			)}
			{children}
		</ConfettiContext.Provider>
	)
}
